var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { ChevronLeft, ChevronRight, clickableStyle, Divider, IconButton, makeStyles, Typography } from "../../../../index";
import { useDeclarativeLoading } from "../../../../hooks/useLoading";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        height: '100%',
        position: 'relative',
        overflow: 'auto',
    },
    sidebar: {
        width: 240,
        overflow: 'auto',
    },
    sidebarItem: __assign({ display: 'flex', alignItems: 'center', height: 48, padding: theme.spacing(0, 3) }, clickableStyle(theme)),
    activeSidebarItem: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.dark.text.primary,
    },
    sideBarLabel: {
        wordBreak: 'break-all',
        display: '-webkit-box',
        overflow: 'hidden',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
    },
    rightPane: {
        display: 'flex',
        flexDirection: 'column',
        width: "calc(100% - 240px - " + theme.shape.borderWidth.normal + "px)",
        padding: theme.spacing(0.5),
    },
    information: {
        width: 'calc(100% - 96px)',
        height: 80,
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
        overflow: 'auto',
    },
    informationItem: {
        overflow: 'visible',
    },
    informationButton: {
        position: 'absolute',
        width: 48,
        height: 48,
        right: theme.spacing(3),
        bottom: theme.spacing(2),
    },
    main: {
        flex: 1,
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        overflow: 'auto',
    },
    content: __assign({ display: 'flex', flexDirection: 'column', margin: theme.spacing(0.5), padding: theme.spacing(0.5) }, clickableStyle(theme)),
    activeContent: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.dark.text.primary,
    },
    label: {
        width: 120,
        fontSize: 14,
        wordBreak: 'break-all',
        display: '-webkit-box',
        overflow: 'hidden',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
    },
    imageWrapper: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.light.text.hint,
        width: 120,
        height: 93,
        position: 'relative',
    },
    image: {
        objectFit: 'contain',
        margin: theme.spacing(1),
        maxWidth: "calc(100% - " + theme.spacing(1) + "px * 2)",
        maxHeight: "calc(100% - " + theme.spacing(1) + "px * 2)",
        position: 'absolute',
        top: "calc(50% - " + theme.spacing(1) + "px)",
        left: "calc(50% - " + theme.spacing(1) + "px)",
        transform: 'translate(-50%, -50%)',
    },
}); });
export var SelectImage = function (props) {
    var activeImage = props.activeImage, activeCategory = props.activeCategory, siblingCategories = props.siblingCategories, contents = props.contents, onChangeImage = props.onChangeImage, onChangeCategory = props.onChangeCategory;
    var classes = useStyles();
    var handleClickCategory = function (category) {
        if (category.id !== (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.id)) {
            onChangeCategory === null || onChangeCategory === void 0 ? void 0 : onChangeCategory(category.id);
        }
    };
    var handleClickContent = function (content) {
        if (content.contentType === 'image' && content.id !== (activeImage === null || activeImage === void 0 ? void 0 : activeImage.id)) {
            onChangeImage === null || onChangeImage === void 0 ? void 0 : onChangeImage(content.id);
        }
        if (content.contentType === 'category') {
            onChangeCategory === null || onChangeCategory === void 0 ? void 0 : onChangeCategory(content.id);
        }
    };
    var _a = useState(false), isInformationVisible = _a[0], setInformationVisibility = _a[1];
    var handleClickInformationButton = useCallback(function () {
        setInformationVisibility(!isInformationVisible);
    }, [isInformationVisible]);
    // イラストを読み込み中はローディング表示にする
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var loadingCounter = useRef(0);
    useEffect(function () {
        if (contents.length > 0) {
            setIsLoading(true);
        }
        loadingCounter.current = 0;
    }, [contents]);
    var handleLoadImage = useCallback(function () {
        // eslint-disable-next-line no-plusplus
        if (++loadingCounter.current === contents.length) {
            setIsLoading(false);
        }
    }, [contents]);
    useDeclarativeLoading('lockLoading', isLoading);
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.sidebar }, siblingCategories.map(function (category) {
            var _a;
            return (React.createElement("div", { key: category.id, className: classNames(classes.sidebarItem, (_a = {},
                    _a[classes.activeSidebarItem] = category.id === (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.id),
                    _a)), onClick: function () { return handleClickCategory(category); } },
                React.createElement("span", { className: classes.sideBarLabel }, category.name)));
        })),
        React.createElement(Divider, { vertical: true }),
        React.createElement("div", { className: classes.rightPane },
            React.createElement("div", { className: classes.main }, contents.map(function (content) {
                var _a;
                return (React.createElement("div", { key: content.id, className: classNames(classes.content, (_a = {},
                        _a[classes.activeContent] = content.id === (activeImage === null || activeImage === void 0 ? void 0 : activeImage.id),
                        _a)), onClick: function () { return handleClickContent(content); } },
                    content.contentType === 'image' && (React.createElement("div", { className: classes.imageWrapper },
                        React.createElement("img", { className: classes.image, src: content.path, onLoad: handleLoadImage, onError: handleLoadImage }))),
                    content.contentType === 'category' && (React.createElement("div", null,
                        React.createElement("img", { src: content.thumbnail, onLoad: handleLoadImage, onError: handleLoadImage }))),
                    React.createElement("span", { className: classes.label }, content.name)));
            })),
            isInformationVisible && (React.createElement(React.Fragment, null,
                React.createElement(Divider, null),
                React.createElement("div", { className: classes.information },
                    React.createElement(Typography, { noWrap: true, className: classes.informationItem }, activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.name),
                    React.createElement(Typography, { noWrap: true, className: classes.informationItem }, activeImage === null || activeImage === void 0 ? void 0 : activeImage.name))))),
        React.createElement("div", { className: classes.informationButton },
            React.createElement(IconButton, { onClick: handleClickInformationButton }, isInformationVisible ? React.createElement(ChevronRight, null) : React.createElement(ChevronLeft, null)))));
};
